import { TransactionInfoWrapper } from '../transactionListInfoStyle'
import React from 'react'
import { TransactionTitleText } from 'src/components/Global/Text/TitleText'
import { getPageTransactions } from 'src/redux/actions/transaction'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useDispatch } from 'react-redux'
import {
  Savingsdebited,
  SavingsHome,
  TransactionImage,
  InvestmentHome,
  InterestHome,
} from 'src/assets'
import { Link } from 'react-router-dom'

const TransactionListing = () => {
  const dispatch = useDispatch()
  const transaction = useTypedSelector(
    (state) => state.transactionsReducer.transactionsResult.transactions
  )

  const transactionLoading = useTypedSelector(
    (state) => state.transactionsReducer.loading
  )

  console.log(transactionLoading)

  const transactionInfo = transaction?.transactions
  console.log(transaction, 'hree')

  console.log(
    new Date('4:17 PM, 2021-04-24').toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }),
    'here'
  )
  const nextPage = () => {
    if (transaction.pagination.next) {
      let url_string = transaction.pagination.next
      var url = new URL(url_string)
      var pageNumber = url.searchParams.get('page')
      console.log(pageNumber)
      dispatch(getPageTransactions(pageNumber))
    }
  }
  const setDate = (item: any) => {
    return new Date(item).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }
  const Image = (item: any) => {
    if (item === 'save') {
      return TransactionImage
    } else if (item === 'withdraw') {
      return Savingsdebited
    } else if (item === 'interest') {
      return InterestHome
    } else {
      return InvestmentHome
    }
  }
  const Status = (item: any) => {
    if (item === 'successful') {
      return 'successful'
    } else if (item === 'failed') {
      return 'failed'
    } else if (item === 'processing') {
      return 'processing'
    } else if (item === 'cancelled') {
      return 'cancelled'
    } else {
      return 'cancelled'
    }
  }
  const CheckStatus = (item: any) => {
    if (item === 'successful') {
      return 'para-successful'
    } else if (item === 'failed') {
      return 'para-failed'
    } else if (item === 'processing') {
      return 'para-processing'
    } else if (item === 'cancelled') {
      return 'para-cancelled'
    } else {
      return 'para-cancelled'
    }
  }
  return (
    <TransactionInfoWrapper>
      {transactionInfo?.length > 0 ? (
        <div>
          {transactionInfo?.map((item: any) => (
            <div className="transactionHeadings lg" key={item.id}>
              <div className="description flex">
                <img src={`${Image(item.type)}`} alt="" className="reduce" />
                <p className="transactionDesc">{item.description}</p>
              </div>
              <div className="amount">
                <p>{item.amount}</p>
              </div>
              <div className="date">
                <p>{`${setDate(item.date)}`}</p>
              </div>
              <div className="type">
                <p>
                  <p className="capitalize">
                    {item.type === 'save' ? 'savings' : item.type}
                  </p>{' '}
                </p>
              </div>
              <div className={`status-last ${Status(item.status)}`}>
                <p className={`${CheckStatus(item.status)}`}>{item.status}</p>
              </div>
            </div>
          ))}
          {transactionInfo.map((item: any) => (
            <div key={item.id} className="transactionHeading mb">
              <div className="trans-flex">
                <div className="">
                  <img src={`${Image(item.type)}`} alt="" className="tranImg" />
                </div>
                <div className="">
                  {/* <h1 className="">{item.smallDescription}</h1> */}
                  <h3 className="type">
                    {item.type === 'save' ? 'savings' : item.type}
                  </h3>
                </div>
              </div>
              <div className="">
                <div className="">
                  <h3>{item.amount}</h3>
                </div>
                <div className="">
                  <h2>{`${setDate(item.date)}`}</h2>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <TransactionTitleText>Oppps....Not Found</TransactionTitleText>
      )}
    </TransactionInfoWrapper>
  )
}

export { TransactionListing }
